export default {
  methods: {
    async setReceipt (receiptData) {
      let alreadyFilledIn = false
      if (this.isCheckoutPageLogin) {
        // 若已填入發票資訊，則不帶入預設資料
        switch (receiptData.type) {
          case 1: // 個人電子發票
            // E-mail
            if (receiptData.mail) alreadyFilledIn = true
            break
          case 2: // 公司統一編號
            // E-mail、公司統一編號
            if (receiptData.companyMail && receiptData.idNumber) alreadyFilledIn = true
            break
          case 3: // 捐贈發票
            if (receiptData.donate) alreadyFilledIn = true
            break
          case 4: // 手機條碼載具
            if (receiptData.barcode) alreadyFilledIn = true
            break
        }
      }
      if (alreadyFilledIn) return
      const receipt = await this.$store.dispatch('getPersonalReceipt')
      if (receipt.Personal) { // 個人電子發票
        receiptData.mail = receipt.Personal.Email
      }
      if (receipt.Company) { // 公司統一編號
        receiptData.companyMail = receipt.Company.Email
        receiptData.idNumber = receipt.Company.TaxIDNumber
      }
      if (receipt.Donate) { // 捐贈發票
        receiptData.donate = receipt.Donate.NPOBAN
      }
      if (receipt.Carrier) { // 手機條碼載具
        receiptData.barcode = receipt.Carrier.Code
      }
      if (receipt.DefaultInvoiceType) {
        receiptData.type = receipt.DefaultInvoiceType
      }
    }
  }
}
